import type { ColumnsType } from 'antd/es/table';

import type { ColumnBuilderParams, DataBuilderParams } from '@/features/(charts)/chart-renderer/ui/Cross/types';

import { CompareColumnBuilder } from '../builders';
import { CompareDataGenerator } from '../generators';
import type { ICrossTableStrategy } from './ICrossTableStrategy';

/**
 * 비교 모드 Strategy
 * 비교 모드의 컬럼과 데이터 소스를 생성
 */
export class CompareStrategy implements ICrossTableStrategy {
  private columnBuilder: CompareColumnBuilder;
  private dataGenerator: CompareDataGenerator;

  constructor(
    columnParams: ColumnBuilderParams,
    dataParams: DataBuilderParams,
  ) {
    this.columnBuilder = new CompareColumnBuilder(columnParams);
    this.dataGenerator = new CompareDataGenerator(dataParams);
  }

  /**
   * 비교 모드 컬럼 생성
   */
  buildColumns(): ColumnsType<any> {
    return this.columnBuilder.buildColumns();
  }

  /**
   * 비교 모드 데이터 소스 생성
   */
  buildDataSource(): Record<string, StringNumberValue | null>[] {
    return this.dataGenerator.buildDataSource();
  }
}
